<template>
  <div
    class="widget-container"
    v-b-tooltip.hover.left
    :title="$t('dashboard.freshdeskWidgetDisabled')"
  >
    <div class="widget">
      <b-icon-question-circle />
      <p>
        {{ $t('dashboard.freshdeskWidget') }}
      </p>
    </div>
  </div>
</template>
<script>
import { BIconQuestionCircle } from 'bootstrap-vue'
export default {
  components: {
    BIconQuestionCircle
  }
}
</script>
<style>
.tooltip-inner {
  width: auto !important;
  max-width: 300px !important;
}
</style>
<style lang="scss" scoped>
.widget-container {
  position: sticky;
  width: fit-content;
  z-index: 1;
  bottom: 30px;
  left: 90%;
  .widget {
    border-radius: 20px;
    border-top-right-radius: 8px;
    background-color: $neutral-gray-200;
    display: flex;
    align-items: center;
    padding: 8px;
    padding-right: 16px;
    &:hover {
      cursor: not-allowed;
    }
    p {
      margin: 0;
      font-size: 0.875rem;
      font-weight: 600;
      margin-left: 10px;
    }
  }
}
</style>
